import { render, staticRenderFns } from "./tokenization.vue?vue&type=template&id=4c44fd32"
import script from "./tokenization.vue?vue&type=script&lang=js"
export * from "./tokenization.vue?vue&type=script&lang=js"
import style0 from "./tokenization.vue?vue&type=style&index=0&id=4c44fd32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports